import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "ps-0 mt-0" }
const _hoisted_2 = { class: "d-flex justify-space-between" }
const _hoisted_3 = { class: "column mt-20" }
const _hoisted_4 = {
  key: 0,
  class: "d-flex flex-column justify-space-center align-items-center text-center w-100 py-15"
}
const _hoisted_5 = { class: "v-card-header border-bottom" }
const _hoisted_6 = { class: "d-flex justify-space-between align-items-center w-100" }
const _hoisted_7 = { class: "mb-0" }
const _hoisted_8 = { class: "box" }
const _hoisted_9 = { class: "fw-semibold mb-15" }
const _hoisted_10 = { class: "list ps-0 mb-0 mt-0" }
const _hoisted_11 = { class: "gray-color position-relative" }
const _hoisted_12 = { class: "gray-color position-relative" }
const _hoisted_13 = { class: "gray-color position-relative" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_DeleteAddressModal = _resolveComponent("DeleteAddressModal")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!

  return (_openBlock(), _createBlock(_component_v_card, { class: "mb-25 pingo-card" }, {
    default: _withCtx(() => [
      _cache[11] || (_cache[11] = _createElementVNode("div", { class: "v-card-header border-bottom" }, [
        _createElementVNode("h5", { class: "mb-0" }, "Configurações")
      ], -1)),
      _createElementVNode("ul", _hoisted_1, [
        _createElementVNode("li", null, [
          _createVNode(_component_router_link, { to: "/configuracoes/conta" }, {
            default: _withCtx(() => _cache[0] || (_cache[0] = [
              _createTextVNode(" Conta ")
            ])),
            _: 1
          })
        ]),
        _createElementVNode("li", null, [
          _createVNode(_component_router_link, { to: "/configuracoes/enderecos" }, {
            default: _withCtx(() => _cache[1] || (_cache[1] = [
              _createTextVNode(" Endereços ")
            ])),
            _: 1
          })
        ]),
        _createElementVNode("li", null, [
          _createVNode(_component_router_link, { to: "/configuracoes/politica-de-privacidade" }, {
            default: _withCtx(() => _cache[2] || (_cache[2] = [
              _createTextVNode(" Política de Privacidade ")
            ])),
            _: 1
          })
        ]),
        _createElementVNode("li", null, [
          _createVNode(_component_router_link, { to: "/configuracoes/termos-e-condicoes" }, {
            default: _withCtx(() => _cache[3] || (_cache[3] = [
              _createTextVNode(" Termos e Condições ")
            ])),
            _: 1
          })
        ])
      ]),
      _createElementVNode("form", null, [
        _createElementVNode("div", _hoisted_2, [
          _cache[5] || (_cache[5] = _createElementVNode("div", null, [
            _createElementVNode("h5", { class: "fw-semibold mb-8" }, "Endereços"),
            _createElementVNode("p", null, "Gerencie seus endereços aqui.")
          ], -1)),
          _createVNode(_component_router_link, { to: "/configuracoes/endereco/novo" }, {
            default: _withCtx(() => _cache[4] || (_cache[4] = [
              _createElementVNode("button", {
                type: "button",
                class: "default-btn px-8"
              }, "Novo endereço", -1)
            ])),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_3, [
          (_ctx.isLoadingAdresses)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _createVNode(_component_v_progress_circular, {
                  class: "mb-8",
                  color: "primary",
                  indeterminate: ""
                }),
                _cache[6] || (_cache[6] = _createElementVNode("span", { class: "gray-color fw-medium d-inline-block" }, "Carregando...", -1))
              ]))
            : _createCommentVNode("", true),
          (!_ctx.isLoadingAdresses)
            ? (_openBlock(), _createBlock(_component_v_row, { key: 1 }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.addresses, (address, index) => {
                    return (_openBlock(), _createBlock(_component_v_col, {
                      key: index,
                      cols: "12",
                      lg: "4",
                      md: "4",
                      sm: "6"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_card, { class: "pingo-card address-card" }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_5, [
                              _createElementVNode("div", _hoisted_6, [
                                _createElementVNode("h5", _hoisted_7, "Endereço #" + _toDisplayString(index + 1), 1),
                                _createVNode(_component_DeleteAddressModal, {
                                  "address-id": address.addressId
                                }, null, 8, ["address-id"])
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_8, [
                              _createElementVNode("h5", _hoisted_9, _toDisplayString(_ctx.user.name), 1),
                              _createElementVNode("ul", _hoisted_10, [
                                _createElementVNode("li", _hoisted_11, [
                                  _cache[7] || (_cache[7] = _createElementVNode("span", { class: "fw-medium d-inline-block" }, "Endereço:", -1)),
                                  _createTextVNode(" " + _toDisplayString(address.street) + " " + _toDisplayString(address.number) + ", " + _toDisplayString(address.neighborhood) + " - " + _toDisplayString(address.city) + ", " + _toDisplayString(address.state) + " " + _toDisplayString(address.zipCode) + ", " + _toDisplayString(address.country), 1)
                                ]),
                                _createElementVNode("li", _hoisted_12, [
                                  _cache[8] || (_cache[8] = _createElementVNode("span", { class: "fw-medium d-inline-block" }, "Complemento:", -1)),
                                  _createTextVNode(" " + _toDisplayString(address.complement || "N/A"), 1)
                                ]),
                                _createElementVNode("li", _hoisted_13, [
                                  _cache[9] || (_cache[9] = _createElementVNode("span", { class: "fw-medium d-inline-block" }, " Endereço padrão: ", -1)),
                                  _createTextVNode(" " + _toDisplayString(address.isDefault ? "Sim" : "Não"), 1)
                                ])
                              ]),
                              _createVNode(_component_v_divider, { class: "my-4" }),
                              _createVNode(_component_router_link, {
                                to: `/configuracoes/endereco/editar/${address.addressId}`
                              }, {
                                default: _withCtx(() => _cache[10] || (_cache[10] = [
                                  _createElementVNode("button", {
                                    type: "button",
                                    class: "default-btn w-100 px-8"
                                  }, " Alterar endereço ", -1)
                                ])),
                                _: 2
                              }, 1032, ["to"])
                            ])
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _: 2
                    }, 1024))
                  }), 128))
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _: 1
  }))
}